import React from 'react';
// import About from "../About/About";
import {
  FaFacebook,
  FaGithub,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
} from 'react-icons/fa';
import {
  FooterContainer,
  FooterWrap,
  FooterTextContainer,
  FooterTextWrapper,
  FooterItems,
  FooterTextTitle,
  FooterText,
  SocialMedia,
  SocialMediaWrap,
  SocialMediaText,
  SocialIcons,
  SocialIconLink,
  WebsiteRights,
} from './FooterElements';

const Footer = () => {
  return (
    <FooterContainer id="contact">
      <FooterWrap>
        <FooterTextContainer>
          <FooterTextWrapper>
            <FooterItems>
              <FooterTextTitle>Contact Me</FooterTextTitle>
              <FooterText>Email Me - nirajsrivastava2001@gmail.com</FooterText>
            </FooterItems>
          </FooterTextWrapper>
        </FooterTextContainer>
        <SocialMedia>
          <SocialMediaWrap>
            <SocialMediaText>Follow Me On!</SocialMediaText>
            <SocialIcons>
              <SocialIconLink
                href="https://www.facebook.com/niraj.srivastava.79"
                target="_blank"
                alt="facebook"
              >
                <FaFacebook />
              </SocialIconLink>
              <SocialIconLink
                href="https://twitter.com/NirajSrivatav24"
                target="_blank"
                alt="facebook"
              >
                <FaTwitter />
              </SocialIconLink>
              <SocialIconLink
                href="https://github.com/NirajSrivastava18"
                target="_blank"
                alt="facebook"
              >
                <FaGithub />
              </SocialIconLink>
              <SocialIconLink
                href="https://www.instagram.com/zdev_18/"
                target="_blank"
                alt="facebook"
              >
                <FaInstagram />
              </SocialIconLink>
              <SocialIconLink
                href="https://www.linkedin.com/in/niraj-srivastava-94800a194/"
                target="_blank"
                alt="facebook"
              >
                <FaLinkedin />
              </SocialIconLink>
            </SocialIcons>
          </SocialMediaWrap>
        </SocialMedia>
        <WebsiteRights>Niraj Srivastava © 2021</WebsiteRights>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
